/* Vintedoisk — resposta ao clique no "Adicionar à sacola" (24/10/2026). Carregado só no template de produto.
   1) ao clicar o botão afunda (CSS)  2) "Adicionando…" enquanto espera (o tema já trava o botão)
   3) "✓ Adicionada à sacola" só quando a peça ENTROU (evento cart-update do tema; erro = cart-error → volta ao normal).
   Não altera o product-form.js do tema: observa a classe "loading" que ele põe e tira. */
(function () {
  var resultado = null; // 'ok' | 'erro' da última tentativa

  function iniciar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.source === 'product-form-component') resultado = 'ok'; });
      subscribe(PUB_SUB_EVENTS.cartError, function (e) { if (e && e.source === 'product-form-component') resultado = 'erro'; });
    }
    document.querySelectorAll('.product-details button[name="add"], sticky-atc button[name="add"]').forEach(preparar);
  }

  function preparar(btn) {
    if (btn.dataset.vkPronto) return;
    btn.dataset.vkPronto = '1';
    var msg = document.createElement('span');
    msg.className = 'vk-botao-msg';
    msg.setAttribute('aria-live', 'polite');
    btn.appendChild(msg);
    var timer;
    var limpar = function () { delete btn.dataset.vkEstado; msg.textContent = ''; };

    new MutationObserver(function () {
      if (btn.classList.contains('loading')) {
        if (btn.dataset.vkEstado === 'adicionando') return;
        clearTimeout(timer);
        resultado = null;
        btn.dataset.vkEstado = 'adicionando';
        msg.textContent = 'Adicionando…';
      } else if (btn.dataset.vkEstado === 'adicionando') {
        if (resultado !== 'ok') return limpar(); // erro ou sem confirmação: o tema mostra a mensagem dele
        btn.dataset.vkEstado = 'adicionada';
        msg.textContent = '✓ Adicionada à sacola';
        timer = setTimeout(limpar, 1800);
      }
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
